// extracted by mini-css-extract-plugin
export var wordContainer = "_ik-0";